module.exports = __webpack_public_path__ + "img/dayzero.ad14a7b0.png";